const opioidMedNameIds = [
  '63',
  '76',
  '250',
  '326',
  '762',
  '920',
  '979',
  '993',
  '998',
  '1019',
  '1085',
  '1413',
  '1495',
  '1497',
  '1579',
  '1746',
  '1849',
  '1851',
  '2185',
  '2389',
  '2390',
  '2490',
  '2634',
  '2759',
  '2760',
  '2761',
  '2804',
  '2823',
  '2882',
  '2883',
  '2897',
  '2903',
  '2904',
  '3138',
  '3139',
  '3347',
  '3406',
  '3407',
  '3413',
  '3421',
  '3425',
  '3453',
  '3589',
  '3853',
  '3988',
  '4009',
  '4016',
  '4029',
  '4302',
  '4530',
  '4531',
  '6038',
  '6370',
  '6991',
  '6992',
  '7128',
  '8181',
  '8599',
  '9168',
  '10362',
  '10547',
  '10567',
  '11232',
  '13106',
  '13893',
  '14216',
  '14217',
  '14526',
  '14530',
  '14943',
  '14968',
  '15052',
  '15101',
  '15106',
  '15313',
  '15860',
  '20445',
  '20447',
  '20728',
  '20908',
  '26210',
  '26510',
  '47293',
  '49008',
  '57342',
  '57343',
  '63559',
  '65093',
  '65094',
  '76838',
  '78041',
  '78105',
  '78579',
  '80142',
  '80263',
  '80593',
  '110024',
  '110303',
  '110304',
  '110390',
  '110391',
  '111200',
  '114062',
  '114258',
  '114834',
  '115307',
  '115543',
  '115640',
  '115663',
  '115785',
  '116080',
  '116257',
  '117159',
  '117268',
  '117284',
  '117401',
  '118171',
  '118172',
  '118522',
  '118533',
  '118556',
  '119294',
  '119490',
  '124100',
  '124240',
  '126320',
  '133360',
  '142266',
  '143065',
  '147328',
  '149788',
  '232345',
  '239085',
  '244625',
  '246866',
  '251445',
  '253606',
  '253607',
  '253608',
  '260305',
  '262685',
  '266165',
  '266265',
  '272165',
  '274765',
  '276845',
  '277265',
  '309785',
  '310465',
  '312845',
  '319285',
  '322085',
  '337096',
  '337097',
  '339704',
  '340640',
  '346876',
];

const isOpioid = (medNameId: number | string) => {
  return opioidMedNameIds.includes(medNameId?.toString());
};

export default isOpioid;
